module.exports = __webpack_public_path__ + "static/media/6.3dd34f8c.JPG";